export default __webpack_public_path__ + "static/media/PrgmH3.08594645.png";